import React from "react";
import VehicleCustomerRequirementDate from "./VehicleCustomerRequirementDate";
import VehicleCustomerRequirementViewCard from "./VehicleCustomerRequirementViewCard";
import { useNavigate } from "react-router-dom";
import {
  moneyReceiptFormatter,
  viewCustomerAgreementFormatterFunc,
  viewCustomerFormatterFunc,
  viewDeliveryFormatterFunc,
  viewLoanFormatterFunc
} from "../../../../utils/moneyReceipt.utils";
import { deliveryDate } from "../../../../utils/date.utils";
import Hover from "../../../../components/styled/Hover";

export default function VehicleCustomerRequirementView({ data, cardIndex }) {
  const navigate = useNavigate();

  const formattedData = moneyReceiptFormatter(data);

  // loan data
  const loan = formattedData?.customer?.loan;

  const handleCollectorView = (username) => {
    if (username) {
      navigate(`/user/${username}/profile`);
    }
  };

  const loanData = viewLoanFormatterFunc(loan, { handleCollectorView });

  // customer data
  const profile = formattedData?.customer?.profile;
  const address = formattedData?.customer?.address;
  const customerId = formattedData?.old?.customer?.customer_id;

  const handleCustomerView = (customer_id) => {
    if (customer_id) {
      navigate(`/customer/${customer_id}/view`);
    }
  };

  const customerData = viewCustomerFormatterFunc(
    { ...profile, address, customer_id: customerId },
    { handleCustomerView }
  );

  // customer agreement data
  const car = formattedData?.car;
  const additionalCost = car?.additionalCost;
  const customerAgreementData = viewCustomerAgreementFormatterFunc({ ...car, additionalCost });

  // vehicle delivery data
  const delivery = formattedData?.customer?.delivery;
  const deliveryData = viewDeliveryFormatterFunc(delivery);

  return (
    <div className="bg-light rounded p-3 position-relative">
      <div className="row g-3">
        <div className="col-6">
          <Hover onClick={() => navigate(`/money-receipt-list/${data?.caid ?? ""}/view`)}>
            {cardIndex ?? ""}#&nbsp;{data?.caid ?? ""}
          </Hover>
        </div>
        <div className="col-6">
          <VehicleCustomerRequirementDate data={deliveryDate(data?.created_at)} />
        </div>
        <div className="col-12 col-md-4">
          <VehicleCustomerRequirementViewCard data={customerData} title="Customer Information" />
        </div>
        <div className="col-12 col-md-4">
          <VehicleCustomerRequirementViewCard data={deliveryData} title="Delivery Infomation" />
        </div>
        <div className="col-12 col-md-4">
          <VehicleCustomerRequirementViewCard
            data={customerAgreementData}
            title="Customer Agreement"
          />
        </div>
        <div className="col-12 col-md-4">
          <VehicleCustomerRequirementViewCard data={loanData} title="Bank Loan" />
        </div>
      </div>
    </div>
  );
}
